export default __webpack_public_path__ + "static/media/ico_eyeOpen.d1720187.svg";